module.exports = __webpack_public_path__ + "static/media/chevron-down.a1347a00.svg";